import { useEffect, useState } from 'react'
import { Outlet } from 'react-router'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { useTelemetryStore } from '../../stores/telemetryStore'
import { SessionTimeoutModal } from '../auth/SessionTimeoutModal'

export function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const connect = useTelemetryStore((s) => s.connect)
  const disconnect = useTelemetryStore((s) => s.disconnect)

  useEffect(() => {
    connect()
    return () => disconnect()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // Voysi flamingo shell: dark 220px sidebar + white header + warm-grey
  // content surface (#FAFAF8 = ink-50).
  return (
    <div className="flex h-screen bg-[var(--color-ink-50)] text-text-primary">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header onMenuToggle={() => setSidebarOpen((o) => !o)} />
        <main className="flex-1 overflow-auto p-5 md:p-7">
          <Outlet />
        </main>
      </div>
      {/* HIPAA §164.312(a)(2)(iii) automatic logoff. Mounted here because
          AppShell is the only authenticated wrapper — every route that can
          render a call transcript is inside it. Renders nothing until the
          idle (or absolute) deadline is close. */}
      <SessionTimeoutModal />
    </div>
  )
}
